import { makeStyles } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import clsx from 'clsx';
import FlagstoneTheme from '../../../config/flagstoneTheme';
import {fromNewDateFormatToDDMMYYYYHHmmssSlash} from '../../../utils/dateHelper';

export default function SelectSQLFilesComponent(props) {

    const classes = useStyles();     
   

    const getBackgroundColor = (executed) => {
        if(executed){
            return "rgba(70, 84, 251,0.1)"
        }
        else{
            return "#FFFFFF"
        }
    }    

    return (

        <div className={classes.container}>
            <div className={classes.title}>{"Select SQL files to be executed on DB " + props.env.DBName }</div>
            <Table className={classes.table} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.leftHeadCell} width={"10%"}>
                            Execute
                        </TableCell>
                        <TableCell className={classes.headCell} width={"50%"} align="left">Name</TableCell>
                        <TableCell className={classes.headCell} width={"10%"} align="left">Executed</TableCell>
                        <TableCell className={classes.headCell} width={"30%"} align="left">Executed On</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.sqlFiles.map((file) => (
                        <TableRow key={file.name} className={classes.row}>
                            <TableCell className={classes.leftCell} style={{backgroundColor:getBackgroundColor(file.executed)}}>
                                <Checkbox
                                    className={classes.checkBox}
                                    disableRipple
                                    color="default"
                                    disabled = {file.executed}
                                    checked={file.toBeExecuted}
                                    onChange={() => props.changeFileToBeExecuted(file.name)}
                                    checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                                    icon={<span className={classes.icon} />}
                                    inputProps={{ 'aria-label': 'decorative checkbox' }}
                                />
                            </TableCell>
                            <TableCell className={classes.midCell}  style={{backgroundColor:getBackgroundColor(file.executed)}} align="left">{file.name}</TableCell>
                            <TableCell className={classes.midCell}  style={{backgroundColor:getBackgroundColor(file.executed)}} align="left">
                                <Checkbox
                                    className={classes.checkBox}
                                    disableRipple
                                    color="default"
                                    checked={file.executed}
                                    readOnly
                                    checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                                    icon={<span className={classes.icon} />}
                                    inputProps={{ 'aria-label': 'decorative checkbox' }}
                                />
                            </TableCell>
                            <TableCell className={classes.rightCell}  style={{backgroundColor:getBackgroundColor(file.executed)}} align="left">{file.executedOn ? fromNewDateFormatToDDMMYYYYHHmmssSlash(file.executedOn) : "/"}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <button className={classes.executeButton} onClick={() => props.execute()} >EXECUTE</button>            
        </div>
    )
}

const useStyles = makeStyles({
    container: {
        padding: "50px",
        width: "100%"
    },
    title: {
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "left",
    },
    leftHeadCell: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        padding: "0px",
        paddingLeft: "20px",
        border: "none",
        height: "10px",
        lineHeight: "0px"
    },
    headCell: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        padding: "0px",
        border: "none",
        height: "10px",
        lineHeight: "0px"
    },
    leftCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        padding: "10px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        borderLeft: "1px solid #DEDEDE",
        borderRadius: "6px 0 0 6px",
        paddingLeft: "20px",
    },
    midCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        padding: "10px",
        paddingRight: "5px",
        paddingLeft: "0px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
    },
    rightCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        padding: "10px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        borderRight: "1px solid #DEDEDE",
        borderRadius: " 0 6px 6px 0",
        paddingRight: "10px",
        paddingLeft: "5px",
    },
    table: {
        borderSpacing: "0 5px !important",
        borderCollapse: "separate !important",
        width: "100%",
        marginTop: "30px"
    },
    checkBox: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
        float: "left"
    },
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
    },
    executeButton: {
        border: "none",
        outline: "none",
        cursor: "pointer",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        marginTop: "30px",
        color: "white",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        fontSize: "18px",
        width: "150px",
        height: "40px"
    }

});